import React, { lazy } from 'react';
import { ArrowRightIcon, ZapIcon, ClipboardCheckIcon, CodeIcon, BrainIcon } from 'lucide-react';
export const WorldClassTalent = () => {
  const differentiators = [{
    icon: <BrainIcon className="w-5 h-5 text-primary" data-id="element-794" />,
    text: 'Senior operators fluent in AI, product strategy, and modern tooling'
  }, {
    icon: <ZapIcon className="w-5 h-5 text-primary" data-id="element-795" />,
    text: 'Rapid experimentation & quick proof-of-concepts with fast iteration'
  }, {
    icon: <CodeIcon className="w-5 h-5 text-primary" data-id="element-796" />,
    text: 'Average 7+ years experience shipping technology products and AI systems'
  }, {
    icon: <ClipboardCheckIcon className="w-5 h-5 text-primary" data-id="element-797" />,
    text: 'Dedicated project manager for coordination and accountability'
  }];
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section id="world-class-talent" className="py-24 bg-purple-50 relative overflow-hidden" data-id="element-798">
      <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-purple-100 to-purple-50 rounded-full opacity-50 -mr-32 -mt-32" data-id="element-799"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-tl from-purple-100 to-purple-50 rounded-full opacity-40 -ml-40 -mb-40" data-id="element-800"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-801">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-16" data-id="element-802">
          <div className="w-full md:w-1/2" data-id="element-803">
            <div className="max-w-xl" data-id="element-804">
              <p className="uppercase text-sm font-medium tracking-wider mb-6 border-b border-primary pb-2 inline-block text-primary-dark" data-id="element-805">
                WORK WITH THE BEST
              </p>
              <h2 className="text-4xl md:text-5xl font-serif italic mb-3" data-id="element-806">
                World-class product & AI talent
              </h2>
              <p className="text-lg mb-6 text-text-secondary" data-id="element-807">
                Work with experienced AI native team who has shipped real
                products and AI systems at top tech companies and startups
                across Hospitality, Real Estate, e-commerce, and enterprise
                SaaS.
              </p>
              <p className="text-lg mb-8 text-text-secondary" data-id="element-808">
                Plus, a dedicated project manager to ensure your engagement
                stays on track from start to finish.
              </p>
              <div className="space-y-4 mb-10" data-id="element-809">
                {differentiators.map((item, index) => <div key={index} className="flex items-start" data-id="element-810">
                    <div className="flex-shrink-0 p-1.5 bg-primary bg-opacity-10 rounded-full mr-3" data-id="element-811">
                      {item.icon}
                    </div>
                    <p className="text-base font-medium text-gray-800" data-id="element-812">
                      {item.text}
                    </p>
                  </div>)}
              </div>
              <button onClick={openCalendly} className="inline-flex items-center justify-center px-6 py-3 rounded-md font-medium bg-primary text-white hover:bg-primary-dark transition-all duration-200" data-id="element-813">
                Book a consult
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-814" />
              </button>
            </div>
          </div>
          <div className="w-full md:w-1/2" data-id="element-815">
            <div className="relative" data-id="element-816">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary opacity-20 rounded-full" data-id="element-817"></div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary opacity-20 rounded-full" data-id="element-818"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kzNjTbN379cu16TN4XqXYA/20250825_1432_Serene_Mountain_Workspace_remix_01k3hbanb7e1h9sr8s5v8eyjy9.png" alt="Professional working with laptop in a serene mountain setting with large windows" className="w-full h-auto rounded-lg shadow-xl relative z-10 object-cover" style={{
              maxHeight: '600px'
            }} loading="lazy" data-id="element-819" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};